import Head from 'next/head';
import type { Thing, WithContext } from 'schema-dts';

type StructuredDataProps<T extends Thing> = {
  data: WithContext<T>;
};

const StructuredData = <T extends Thing>({ data }: StructuredDataProps<T>) => (
  <Head>
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data).replace(/</g, '\\u003c'),
      }}
    />
  </Head>
);

export default StructuredData;
